<!-- 资料库 -->
<template>
  <div class="database">
    <div class="row">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="推荐" name="1"></el-tab-pane>
        <el-tab-pane
          label="收藏"
          name="2"
          :disabled="!$root.stateType.isLogin"
        ></el-tab-pane>
      </el-tabs>
      <div class="base_input">
        <input
          type="text"
          v-if="activeName == 1"
          placeholder="输入关键词搜索"
          v-model="pages.content"
          @focus="showsearch"
          @keyup="search"
          @keyup.enter="search"
        /><img
          class="userimg"
          v-if="activeName == 1"
          src="/static/images/search_icon.png"
          alt=""
          srcset=""
          @click="
            pages.current = 1;
            initData();
          "
        />
        <input
          type="text"
          v-if="activeName == 2"
          placeholder="输入关键词搜索"
          v-model="CollectPages.key"
          @keyup="search"
          @keyup.enter="search"
        /><img
          class="userimg"
          v-if="activeName == 2"
          src="/static/images/search_icon.png"
          alt=""
          srcset=""
          @click="getCollect()"
        />
      </div>
    </div>
    <div class="selice" v-show="activeName == 1">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <img src="/static/images/resource_xiangguandu.png" alt="" srcset="" />
          {{ pages.timeSort ? "时间排序" : "相关度" }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="false"
            >相关度
            <img
              src="/static/images/resource_gougou.png"
              alt=""
              srcset=""
              v-show="!pages.timeSort"
            />
          </el-dropdown-item>
          <el-dropdown-item :command="true"
            >时间排序
            <img
              src="/static/images/resource_gougou.png"
              alt=""
              srcset=""
              v-show="pages.timeSort"
            />
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown @command="setType">
        <span class="el-dropdown-link">
          <img src="/static/images/resource_quanbu.png" alt="" srcset="" />
          {{ pages.type == 0 ? "全部" : pages.type == 1 ? "刊期" : "论文" }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="0"
            >全部
            <img
              src="/static/images/resource_gougou.png"
              alt=""
              srcset=""
              v-show="pages.type == 0"
            />
          </el-dropdown-item>
          <el-dropdown-item command="1"
            >刊期
            <img
              src="/static/images/resource_gougou.png"
              alt=""
              srcset=""
              v-show="pages.type == 1"
            />
          </el-dropdown-item>
          <el-dropdown-item command="2"
            >论文
            <img
              src="/static/images/resource_gougou.png"
              alt=""
              srcset=""
              v-show="pages.type == 2"
            />
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <template v-if="listData.length != 0">
      <div class="list" v-loading="loading" v-if="activeName == 1">
        <div
          class="rowSpan"
          v-for="(item, index) in listData"
          :key="index"
          @click="lookPage(item)"
        >
          <div class="colSpan">
            <h3 :class="item.sp ? 'acv' : ''">
              {{ item.title }}
            </h3>
            <div class="imgbox">
              <span
                class="collection"
                v-if="!item.isCollect"
                title="收藏"
                @click.stop="addCollect(item)"
              >
              </span>
              <span
                class="isCollect"
                v-if="item.isCollect"
                title="取消收藏"
                @click.stop="cancelCollect(item)"
              >
              </span>
              <span
                @click.stop="refExport(item)"
                title="引用"
                class="yinyong"
              ></span>
            </div>
          </div>
          <p>
            <span>作者：{{ item.author }}</span>
            <span>刊名：{{ item.publish }}</span>
            <span>年份：{{ item.year }}</span>
          </p>
          <div class="text">
            <span v-if="!item.looksummary">{{
              item.summary | spliceText(80)
            }}</span>
            <span v-if="item.looksummary">{{ item.summary }}</span>
            <span v-if="!item.looksummary" @click.stop="looksummary(item)"
              ><img
                src="/static/images/resource_xiala_default.png"
                alt=""
                srcset=""
            /></span>
            <span v-if="item.looksummary" @click.stop="pubsummary(item)"
              ><img src="/static/images/writetop_shangla.png" alt="" srcset=""
            /></span>
          </div>
        </div>
      </div>
    </template>
    <div v-if="listData.length == 0 && activeName == 1" class="non404">
      <img src="/static/images/non404_noziliao.png" alt="" srcset="" />
      <p style="margin-top: 38px">没有找到相关资料哦~换个关键词试试~</p>
    </div>
    <div class="list" v-loading="loading" v-if="activeName == 2">
      <div
        class="rowSpan"
        v-for="(item, index) in listData2"
        :key="index"
        @click="lookPage(item)"
      >
        <div class="colSpan">
          <h3 :class="item.sp ? 'acv' : ''">
            {{ item.title }}
          </h3>
          <div class="imgbox">
            <span
              class="isCollect"
              title="取消收藏"
              @click.stop="cancelCollect(item)"
            >
            </span>
            <span
              @click.stop="refExport(item)"
              title="引用"
              class="yinyong"
            ></span>
          </div>
        </div>
        <p>
          <span>作者：{{ item.author }}</span>
          <span>刊名：{{ item.publish }}</span>
          <span>年份：{{ item.year }}</span>
        </p>
        <div class="text">
          <span v-if="!item.looksummary">{{
            item.summary | spliceText(80)
          }}</span>
          <span v-if="item.looksummary">{{ item.summary }}</span>
          <span v-if="!item.looksummary" @click.stop="looksummary(item)"
            ><img
              src="/static/images/resource_xiala_default.png"
              alt=""
              srcset=""
          /></span>
          <span v-if="item.looksummary" @click.stop="pubsummary(item)"
            ><img src="/static/images/writetop_shangla.png" alt="" srcset=""
          /></span>
        </div>
      </div>
      <div v-if="listData2.length == 0" class="non404">
        <img src="/static/images/non404_shoucang.png" alt="" srcset="" />
        <p>还未收藏过资料哦~</p>
      </div>
    </div>
    <div class="flooter" v-if="listData.length > 0 && activeName == 1">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pages.current"
        @current-change="handleCurrentChange"
        :total="total > 500 ? 500 : total"
      ></el-pagination>
    </div>
    <div class="flooter" v-if="listData2.length > 0 && activeName == 2">
      <el-pagination
        background
        :current-page="CollectPages.current"
        layout="prev, pager, next"
        @current-change="handleCurrentChange2"
        :total="total2 > 500 ? 500 : total2"
      ></el-pagination>
    </div>
    <div class="showpage" v-show="showPage" v-loading="page_loading">
      <button class="close" @click="showPage = false">
        <img src="/static/images/tishi_chacha_default.png" alt="" srcset="" />
        关闭全文
      </button>
      <div class="databasePage">
        <div class="page_title">{{ docData.title }}</div>
        <p class="author">
          作者：<span>{{ docData.author }}</span>
        </p>
        <p class="author">
          刊名：<span>{{ docData.publish }}</span>
        </p>
        <p class="author">
          年份：<span>{{ docData.year }}</span>
        </p>
        <template v-if="!pdf">
          <div
            class="content"
            id="content_box"
            @mouseup="aler_ten"
            @mousedown="alert_left"
            v-if="htmls != ''"
            v-html="htmls"
          ></div>

          <div
            class="content"
            v-if="htmls == ''"
            style="text-align: center; color: #989ea2"
          >
            <img
              style="margin-top: 150px"
              src="/static/images/non404_ziliao.png"
              alt=""
              srcset=""
            />
            <p>该资料提取不出全文</p>
            <p>可查看原版资料查看全文内容</p>
            <button
              style="
                width: 90px;
                height: 30px;
                background: linear-gradient(0deg, #5676bd 0%, #6687c8 100%);
                border-radius: 15px;
                color: #ffffff;
                margin-top: 15px;
              "
              @click="get_pdf()"
            >
              查看原版
            </button>
          </div>
        </template>
        <template v-if="pdf">
          <div class="content">
            <!-- <img v-for="(item, index) in pdflist" :key="index" style="width: 100%" :src="item" alt="" srcset="" /> -->
            <el-image
              v-for="(item, index) in pdflist"
              :key="index"
              :src="item"
              class="detail-image"
              style="width: 100%; height: 100%"
              :preview-src-list="pdflist"
              fit="contain"
              @click="handleClickPreviewImage"
            >
            </el-image>
          </div>
        </template>
        <div
          id="ab_btn"
          :style="'top:' + ab_top + 'px;left:' + ab_left + 'px'"
          v-if="$root.stateType.show_ab_btn"
        >
          <div class="buttons">
            <div @click="addref(xz_text)">
              <img src="/static/images/qipao_yinyong_hover.png" alt="" />
              <p>引用文本</p>
            </div>
            <div @click="addnoteDoc">
              <img src="/static/images/qipao_notes_hover.png" alt="" />
              <p>加入笔记</p>
            </div>
            <!-- <div @click="btn_search">
                        <img src="/static/images/qipao_sousuo_hover.png" alt="" />
                        <p>搜索资料</p>
                    </div> -->
          </div>
        </div>
      </div>
      <div class="flootbtn">
        <div>
          <!-- <button class="eachte">
                    文内图表<img src="/static/images/writetop_xiala.png" alt="" srcset="" />
                </button> -->
        </div>

        <div style="display: flex;z-index: 100;">
          <button
            class="sc"
            v-if="!docData.isCollect"
            @click="addCollect(docData)"
          >
            <img
              src="/static/images/chankanquanwen_shoucang.png"
              alt=""
              srcset=""
            />
            收藏
          </button>
          <button
            class="sc"
            v-if="docData.isCollect"
            @click="cancelCollect(docData)"
          >
            <img
              src="/static/images/resource_collection_hover.png"
              alt=""
              srcset=""
            />
            取消
          </button>
          <button class="yy" @click="refExport(docData)">
            <img
              src="/static/images/chakanquanwen_yinyong.png"
              alt=""
              srcset=""
            />引用
          </button>
          <button class="look_pages" v-if="!pdf" @click="get_pdf()">
            查看原版
          </button>
          <el-tooltip effect="dark" placement="top-end">
            <div slot="content" style="padding 5px; line-height:24px">点击查看纯文字版，可直接<br/>复制内容到论文中</div>
             <button class="look_pages" v-if="pdf" @click="getOriginDetail()">
              转换为文字版
            </button>
          </el-tooltip>
        </div>
      </div>
    </div>

    <div class="showSearch" v-show="showSearch" v-loading="searchloading">
      <div class="searchBox">
        <div style="display: flex; width: 100%">
          <div class="inputBox">
            <input
              class="searchInput"
              type="text"
              v-model="searchKey"
              @focus="getloc()"
              @blur="closeSelect()"
              placeholder="请输入关键词"
            />
            <div v-show="showselect" class="locs">
              <p
                v-if="loclist.length == 0"
                style="text-align: center; color: #cccccc; margin-top: 10px"
              >
                暂无历史记录
              </p>
              <div class="titlerow" v-if="loclist.length != 0">
                <span>历史记录</span> <button @click="clearLoc()">清空</button>
              </div>
              <ul>
                <li
                  v-for="(item, index) in loclist"
                  @click="searchKey = item"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <button class="searchBtn" @click="getSearch">搜索</button>
        </div>
        <button class="close" @click="showSearch = false">取消</button>
      </div>
      <div v-if="searchData.length == 0" class="non404">
        <img src="/static/images/non404_noziliao.png" alt="" srcset="" />
        <p style="margin-top: 38px">没有找到相关资料哦~换个关键词试试~</p>
      </div>

      <div class="list" style="padding: 0; margin: 30px 0; height: 75vh">
        <div class="rowSpan" v-for="(item, index) in searchData" :key="index">
          <div class="colSpan">
            <h3 :class="item.sp ? 'acv' : ''">
              {{ item.title }}
            </h3>
            <div class="imgbox">
              <span
                class="isCollect"
                title="取消收藏"
                @click="cancelCollect(item)"
              >
              </span>
              <span
                @click="refExport(item)"
                title="引用"
                class="yinyong"
              ></span>
            </div>
          </div>
          <p>
            <span>作者：{{ item.author }}</span>
            <span>刊名：{{ item.publish }}</span>
            <span>年份：{{ item.year }}</span>
          </p>
          <div class="text" @click="lookPage(item)">
            <span v-if="!item.looksummary">{{
              item.summary | spliceText(80)
            }}</span>
            <span v-if="item.looksummary">{{ item.summary }}</span>
            <span v-if="!item.looksummary" @click="looksummary(item)"
              ><img
                src="/static/images/resource_xiala_default.png"
                alt=""
                srcset=""
            /></span>
            <span v-if="item.looksummary" @click="pubsummary(item)"
              ><img src="/static/images/writetop_shangla.png" alt="" srcset=""
            /></span>
          </div>
        </div>
      </div>
      <div class="flooter" v-if="searchData.length > 0">
        <el-pagination
          background
          :current-page="CollectPages.current"
          layout="prev, pager, next"
          @current-change="handleCurrentChange2"
          :total="total3 > 500 ? 500 : total3"
        ></el-pagination>
      </div>
    </div>

    <el-dialog :visible.sync="dialogFormVisible" width="600px" :modal="false">
      <div class="title">
        引用
        <span style="color: #989ea2; font-weight: 400">
          (点击引用格式将对应的引用格式直接插入论文)</span
        >
      </div>
      <div class="reflist">
        <div class="lab">
          <div class="labrow" @click="addref(refList.gb)">
            <span>GB</span>
            <span>{{ refList.gb }}</span>
          </div>
          <div class="labrow" @click="addref(refList.mla)">
            <span>Mla</span>
            <span>{{ refList.mla }}</span>
          </div>
          <div class="labrow" @click="addref(refList.apa)">
            <span>Apa</span>
            <span>{{ refList.apa }}</span>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="limit-open-vip">
       <el-dialog
        :visible.sync="opneVipVisible"
        width="500px"
        top="30vh"
        title="转换为文字版">
        <div class="open-vip-box">
          <div class="open-vip-box-message">2次转换文字版机会已用完，开通会员继续享受</div>
          <button
              @click="goVip"
              class="check-glod-btn"
              style="margin-right:16px"
            >
              <span class="check-btn-text">开通会员</span>
            </button>
        </div>
      </el-dialog>
    </div>

    <el-dialog
      :close-on-click-modal= "false"
      :visible.sync="opneVipVisible"
      width="500px"
      top="30vh"
      title="转换为文字版">
      <div class="open-vip-box">
         <div class="open-vip-box-message">2次转换文字版机会已用完，开通会员继续享受</div>
        <button
            @click="goVip"
            class="check-glod-btn"
            style="margin-right:16px"
          >
            <span class="check-btn-text">开通会员</span>
          </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["title"],

  data: function() {
    return {
      activeName: "1",
      putVal: "",
      command: "a",
      ab_top: 0,
      ab_left: 0,
      showPage: false,
      showSearch: false,
      show_ab_btn: false,
      dialogFormVisible: false,
      showselect: false,
      loading: false,
      searchloading: false,
      page_loading: false,
      searchKey: "",
      pdf: true,
      pages: {
        content: "",
        current: 1,
        size: 10,
        type: 0,
        timeSort: false
      },
      seachpage: {
        content: "",
        current: 1,
        size: 10,
        type: 0,
        timeSort: false
      },
      CollectPages: {
        current: 1,
        size: 10,
        key: ""
      },

      xz_text: "",
      loclist: [],
      searchData: [],
      docData: "",
      total: 0,
      total2: 0,
      total3: 0,
      listData: [],
      listData2: [],
      refList: {},
      htmls: "",
      value: "",
      pdflist: [],
      docId: "",
      transferTimes: 0, // 查看原文次数
      rane: window.getSelection(),
      opneVipVisible: false
    };
  },
  components: {},
  created: function() {
    //this.initData()
    this.getTransferTimes();
  },
  mounted: function() {},
  beforeDestroy() {},
  methods: {
    showsearch() {},
    /**
     * 添加笔记
     */
    addnoteDoc: function() {
      if (this.xz_text.trim().length > 500) {
        this.$message({
          message: "添加笔记，不超过500字",
          type: "warning"
        });
        return false;
      }
      let data = {
        content: this.xz_text,
        docId: this.docData.docId
      };
      this.api.noteDoc(data).then(res => {
        if (res.code == 0) {
          let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 添加成功</div>`;
          this.$message({
            dangerouslyUseHTMLString: true,
            iconClass: "none",
            showClose: true,
            message: mgs,
            customClass: "mymessage",
            duration: 1000
          });
        }
      });
    },
    openPage: function(id) {
      this.initData();
      this.lookPage({
        docId: id
      });
    },
    get_pdf: function() {
      this.api
        .pdfView({
          docId: this.docId
        })
        .then(res => {
          if (res.code == 0) {
            this.pdflist = res.data.imgUrls || [];
            this.pdf = true;
          }
        });
      this.page_loading = false;
    },
    // 获取文字版原文
    getOriginDetail: function() {
      this.api.getToolsLimitCheck({type: 1}).then(res => {
        if( res.code == 0) {
          this.pdf = false;
          this.api
            .collectDetail({
              docId: this.docId
            })
            .then(res => {
              this.docData = res.data;
              this.api.gethtml(this.docData.textUrl).then(res => {
                this.page_loading = false;
                if (res.code != 404) {
                  this.htmls = res;
                }
              });
            });
          setTimeout(() => {}, 10000);
        } else {
           this.opneVipVisible = true;
        }
      })

    },
    // 校验查看原文次数 (这个地方用次数表示，没有用true 或false表示，主要是考虑后期提示的次数是否需要从后台读取的可配置数据)
    validateTransferTimes: function() {
      let _this = this;
      this.api.getToolsLimitCheck({
        type: 1
      }).then(res => {
        if (res.code == 0) {
          this.transferTimes = 1;
        } else {
          this.transferTimes = 0;
          this.opneVipVisible = true;
        }
      });
    },

    goVip: function() {
      this.opneVipVisible = false;
      this.$parent.goVip();
    },

    btn_search: function() {
      this.searchKey = this.xz_text;
      this.showSearch = true;
      this.show_ab_btn = false;
      this.getSearch();
    },
    /**
     * 引用文本
     */
    addyin: function() {},
    closeSelect: function() {
      setTimeout(() => {
        this.showselect = false;
      }, 200);
    },
    clearLoc: function() {
      this.loclist = [];
      localStorage.removeItem("searchList");
    },
    getloc: function() {
      if (localStorage.getItem("searchList")) {
        this.loclist = JSON.parse(localStorage.getItem("searchList"));
      }
      this.showselect = true;
    },
    getSearch: function() {
      if (!localStorage.getItem("searchList")) {
        let arr = [];
        arr.push(this.searchKey);
        localStorage.setItem("searchList", JSON.stringify(arr));
      } else {
        let arr = JSON.parse(localStorage.getItem("searchList"));
        if (arr.indexOf(this.searchKey) == -1) {
          arr.push(this.searchKey);
        }
        localStorage.setItem("searchList", JSON.stringify(arr));
      }
      this.seachpage.content = this.xz_text;
      this.searchloading = true;
      this.api.getdatabase(this.seachpage).then(res => {
        this.searchData = res.data.rows;
        this.total3 = res.data.count;
        this.searchloading = false;
      });
    },
    /**
     * 获取选中的文字
     */
    alert_left: function(event) {
      this.$root.stateType.show_ab_btn = false;
      // this.ab_left =
      //   document.getElementsByTagName("body")[0].clientWidth -
      //   event.screenX -
      //   310;
      // if (this.ab_left < 0) {
      //   this.ab_left = 0;
      // }
      // this.ab_top = event.screenY - 310;
      let parent = document.getElementsByClassName("databasePage")[0];
      let parentOffset = this.getOffsetByBody(parent);
      this.ab_left = event.clientX - parentOffset.offsetLeft;
      if (parent.clientWidth - this.ab_left < 294) {
        this.ab_left = 294
      }
      this.ab_top = event.clientY - parent.offsetTop;
      if (parent.clientHeight - this.ab_top <= 85) {
        this.ab_top = parent.clientHeight - 150;
      } else {
        this.ab_top -= 140;
      }
    },
    aler_ten: function(event) {
      setTimeout(() => {
        let selection = window.getSelection();
        this.rane = selection;
        if (selection.anchorOffset != selection.extentOffset) {
          this.xz_text = window.getSelection().toString();
          this.$root.stateType.show_ab_btn = true;
        }
      }, 50);
    },

    /**
     * 查看详情
     */
    lookPage: function(item) {
      this.checkLogin();
      this.showPage = true;
      // this.showSearch = true,
      this.htmls = "";
      this.page_loading = true;
      this.showSearch = false;
      this.pdf = true;
      this.docId = item.businessId || item.docId;
      this.docData = item;
      this.get_pdf();
      setTimeout(() => {}, 10000);
    },

    /**
     * 插入参考文献
     */
    addref: function(item) {
      if (!this.$root.stateType.isLogin) {
        return false;
      }
      let editor = document.getElementById("editor");
      if (!document.getElementById("refExport")) {
        let blockquote = ` <div divContent="divContent">&#8302</div><div divContent="divContent">&#8302</div>  <blockquote id="refExport" style="background: #F5F6FA">
                <h1 style="padding:16px">参考文献</h1>
                <p style="padding:16px">[1]${item}</p>
                </blockquote>`;
        editor.innerHTML += blockquote;
      } else {
        let p = document.createElement("p");
        p.setAttribute("class", "refExport");
        p.setAttribute("style", "padding:16px");
        let text = document.createTextNode(
          `[${
            document.getElementById("refExport").getElementsByTagName("p")
              .length
          }]${item}`
        );
        p.append(text);
        document.getElementById("refExport").appendChild(p);
      }
      this.dialogFormVisible = false;
      this.$message({
        message: "引用成功",
        type: "success"
      });
      //调用edition的保存接口，保存数据
      this.$parent.saveWriting();
    },
    /**
     * 文献引用
     */
    refExport: function(item) {
      this.checkLogin();
      this.dialogFormVisible = true;

      var refData = {
        docId: item.businessId || item.docId
      };

      this.api.refExport(refData).then(res => {
        if (res.code == 0) {
          this.refList = res.data;
        }
      });
    },

    /**
     * 添加收藏
     */
    addCollect: function(item) {
      this.checkLogin();
      let addData = {
        author: item.author,
        businessId: item.docId,
        publish: item.publish,
        summary: item.summary,
        title: item.title,
        type: 0,
        year: item.year
      };
      this.api.addCollect(addData).then(res => {
        if (res.code == 0) {
          let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 收藏成功</div>`;
          this.$message({
            dangerouslyUseHTMLString: true,
            iconClass: "none",
            showClose: true,
            message: mgs,
            customClass: "mymessage",
            duration: 2000
          });
          item.isCollect = true;
        }
      });
    },
    looksummary(item) {
      item.looksummary = true;
      this.listData = JSON.parse(JSON.stringify(this.listData));
      this.listData2 = JSON.parse(JSON.stringify(this.listData2));
      this.searchData = JSON.parse(JSON.stringify(this.searchData));
    },
    pubsummary(item) {
      item.looksummary = false;
    },
    /**
     * 取消收藏
     */
    cancelCollect: function(item) {
      this.checkLogin();
      let addData = {
        businessId: item.docId
      };

      if (this.activeName == 2) {
        addData.businessId = item.businessId || item.docId;
      }
      this.api.cancelCollect(addData).then(res => {
        if (res.code == 0) {
          let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 取消收藏成功</div>`;
          this.$message({
            dangerouslyUseHTMLString: true,
            iconClass: "none",
            showClose: true,
            message: mgs,
            customClass: "mymessage",
            duration: 2000
          });
          item.isCollect = false;
          if (this.activeName == 2) {
            if (this.listData2.length == 1 && this.CollectPages.current > 1) {
              this.CollectPages.current -= 1;
            }
            this.getCollect();
          }
        }
      });
    },

    handleClick: function(tab, event) {
      if (tab.name == 1) {
        this.initData();
      }

      if (tab.name == 2) {
        this.getCollect();
      }
    },
    handleCommand: function(command) {
      this.checkLogin();
      this.pages.current = 1;
      this.pages.timeSort = command;
      this.initData();
    },
    /**
     * 搜索按钮
     */
    search: function(val) {
      if (val.keyCode == 13) {
        if (this.activeName == 1) {
          this.pages.current = 1;
          this.initData();
        }
        if (this.activeName == 2) {
          this.getCollect();
        }
      }
    },
    async getmock() {
      var mocke = await import("../../../static/js/mocdata");
      return mocke.default;
    },
    /**
     * 初始化推荐列表
     */
    initData: function() {
      if (!this.$root.stateType.isLogin) {
        this.getmock().then(res => {
          this.listData = res.database.data.rows;
        });
        this.total = 1;
        return false;
      }
      document.getElementsByClassName("list")[0].scrollTop = 0;
      if (this.pages.content == "") {
        this.pages.content = this.title;
      }
      if (this.title.length == 0) {
        let _this = this;
        this.$prompt("输入标题名称", "", {
          closeOnClickModal: false,
          cancelButtonClass: "myno",
          confirmButtonClass: "next",
          confirmButtonText: "确定",
          inputValue: _this.title.trim(),
          inputPlaceholder: "输入关键词或论文标题（建议5-50字）",
          cancelButtonText: "取消",
          inputPattern: /^.{5,51}$/,
          inputErrorMessage: "标题字数需不少于5字",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              _this.pages.content = instance.inputValue;
              instance.confirmButtonLoading = false;
              _this.$emit("setTitle", instance.inputValue);
              _this.initData();
              done();
            } else {
              done();
            }
          }
        }).catch(() => {
          this.$emit("museDr");
        });
        return false;
      }

      this.loading = true;
      this.api.getdatabase(this.pages).then(res => {
        this.loading = false;
        this.listData = res.data.rows;
        this.total = res.data.count;
      });
    },
    /**
     * 获取收藏列表
     */
    getCollect: function() {
      this.loading = true;
      document.getElementsByClassName("list")[0].scrollTop = 0;
      this.api.getCollect(this.CollectPages).then(res => {
        if (res.code == 0) {
          this.loading = false;
          this.listData2 = res.data.records;
          this.total2 = res.data.total;
        }
      });
    },
    /**
     * 下拉菜单点击
     */
    setType: function(command) {
      this.checkLogin();
      this.pages.type = command;
      this.listData = [];
      this.initData();
    },
    /**
     * 分页
     */
    handleCurrentChange: function(val) {
      this.pages.current = val;
      this.initData();
    },
    handleCurrentChange2: function(val) {
      this.CollectPages.current = val;
      this.getCollect();
    },

    /**登录校验 */
    checkLogin: function() {
      if (!this.$root.stateType.isLogin) {
        this.$message({
          message: "此功能登录才能使用",
          type: "warning"
        });
        return false;
      }
    },

    /** 获取阅读文献次数 */
    getTransferTimes: function() {
      this.api.getToolsLimitCheck({type: 1}).then(res => {
        if (res.code == 0) {
          this.transferTimes = 1;
        } else {
          this.transferTimes = 0;
        }
      })
    },

    handleClickPreviewImage: function() {
      this.$nextTick(() => {
        let domImageCanvasImg = document.querySelector(".el-image-viewer__canvas img");
        //TODO 点击图片关闭待定

         let domImageMask = document.querySelector(".el-image-viewer__mask");
          if (!domImageMask) {
            return;
          }
          domImageMask.addEventListener("click", ()=>{
            document.querySelector(".el-image-viewer__close").click();
          })


      })
    },

    getOffsetByBody(el) {
      let offset = {
        offsetTop: 0,
        offsetLeft: 0
      }
      while(el && el.tarName != 'BODY') {
        offset.offsetTop += el.offsetTop;
        offset.offsetLeft += el.offsetLeft;
        el = el.offsetParent
      }
      return offset;
    }

  }
};
</script>

<style lang="scss" scoped>
.database {
  position: relative;

  .showpage {
    position: absolute;
    width: calc(100% - 30px);
    padding: 30px;
    padding-right: 0;
    height: calc(100% - 60px);
    top: 0px;
    background: #ffffff;
    z-index: 3;
    word-break: break-word;

    .databasePage {
      height: calc(100% - 60px);
      padding: 10px 0px;
      position: relative;

      .page_title {
        font-size: 18px;
        font-weight: bold;
        color: #5576bd;
      }

      .author {
        font-size: 12px;
        color: #989da2;
        margin-top: 16px;

        span {
          font-size: 12px;
          color: #58595a;
        }
      }

      .author + .author {
        margin-top: 12px;
      }

      .content {
        line-height: 28px;
        margin-top: 24px;
        height: 80%;
        overflow: auto;

        .detail-image
        /deep/.el-icon-circle-close:before {
                font-size: 36px;
              }
        /deep/ .el-image__preview{
          cursor: -moz-zoom-in;
          cursor: -webkit-zoom-in;
          cursor: zoom-in;
        }

      }
    }

    .close {
      background: none;
      border: none;
      color: #66686e;
    }

    #ab_btn {
       position: absolute;
      .buttons {
        display: flex;
        align-items: center;
        height: 80px;
        justify-content: space-around;
        width: 150px;
        margin-left: 20px;

        div {
          text-align: center;

          p {
            font-size: 12px;
            color: #cccedc;
          }
        }
      }
    }

    .flootbtn {
      display: flex;
      align-items: center;
      justify-content: space-between;

      button {
        color: #333439;
        background: none;
        border: none;
      }

      button + button {
        margin-left: 10px;
      }

      .sc {
        padding: 6px 12px;
        border-radius: 12px;
        background: #f5f6fa;
        display: flex;
        align-items: center;

        img {
          margin-right: 5px;
        }
      }

      .yy {
        padding: 6px 12px;
        border-radius: 12px;
        background: #f5f6fa;

        img {
          margin-right: 5px;
        }
      }

      .look_pages {
        background: $btnc;
        border-radius: 12px;
        color: #ffffff;
        padding: 6px 12px;
      }
    }
  }

  .showSearch {
    position: absolute;
    width: calc(100% - 60px);
    padding: 30px;
    height: calc(100% - 60px);
    top: 0px;
    background: #ffffff;
    z-index: 4;

    .close {
      background: none;
      border: none;
      color: #66686e;
      height: 36px;
      min-width: 50px;
    }

    .searchBox {
      display: flex;

      .inputBox {
        width: 100%;
        height: 34px;
        border: 1px solid #ccc;
        border-radius: 20px 0 0 20px;
        padding-left: 24px;
        position: relative;

        .locs {
          position: absolute;
          box-shadow: 0px 0px 10px 0px rgba(52, 52, 58, 0.2);
          width: calc(100% - 47px);
          left: 15px;
          padding: 16px;
          background: #ffffff;
          margin-top: 5px;
          border-radius: 4px;

          ul {
            padding: 0;
            max-height: 200px;
            overflow: auto;
            margin-top: 24px;

            li {
              color: #34343a;
              line-height: 28px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            li:hover {
              color: $btnc;
            }

            li + li {
              margin-top: 5px;
            }
          }
        }

        .titlerow {
          display: flex;
          justify-content: space-between;
          color: #989ea2;

          button {
            border: none;
            background: none;
            color: #989ea2;
          }
        }
      }

      .searchInput {
        border: none;
        width: 100%;
        height: 34px;
        padding: 0;
      }

      .searchBtn {
        border: none;
        background: $btnc;
        border-radius: 0px 20px 20px 0px;
        color: #ffffff;
        width: 108px;
        height: 36px;
      }
    }
  }

  .non404 {
    text-align: center;
    margin-top: 250px;

    p {
      margin-top: 10px;
      color: #999;
    }
  }

  .lab {
    width: 400px;
    margin: 30px auto;

    .labrow {
      margin-bottom: 10px;
      display: flex;
      cursor: pointer;

      span {
        display: inline-block;
        min-width: 50px;
        color: #66686e;
      }

      span:nth-of-type(1) {
        font-weight: 900;
        height: 100%;
      }

      span:nth-of-type(2):hover {
        color: #5576bd;
      }
    }
  }

  .flooter {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }

  .title {
    margin-top: -30px;

    font-size: 16px;
    font-weight: bold;
    color: #34343a;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px;

    .base_input {
      border-radius: 36px;
      height: 36px;
      border: 1px solid #cccccc;
      padding: 0 10px;
      display: flex;
      align-items: center;
      width: 240px;

      input {
        border: none;
        width: 100%;
      }

      input::-webkit-input-placeholder,
      input::-moz-placeholder,
      input:-moz-placeholder,
      input:-ms-input-placeholder {
        color: red;
      }

      img {
        height: 21px;
        margin-left: 5px;
      }
    }
  }

  .selice {
    padding: 0 40px 10px 40px;
    border-bottom: 1px solid #dedede;

    .el-dropdown {
      margin-right: 40px;

      .el-dropdown-link {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          margin-right: 3px;
        }
      }
    }
  }

  .list {
    height: 68vh;
    overflow: auto;
    padding: 0 40px;
  }

  .rowSpan {
    padding-bottom: 30px;
    margin-top: 30px;

    border-bottom: 1px solid #f5f6fa;
    cursor: pointer;

    .imgbox {
      display: flex;
      margin-left: 20px;

      span {
        margin-left: 10px;
      }
    }

    .collection {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url("/static/images/resource_collection_default.png")
        no-repeat;
    }

    .isCollect {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url("/static/images/resource_collection_hover.png") no-repeat;
    }

    .collection:hover {
      background: url("/static/images/resource_collection_hover.png") no-repeat;
    }

    .yinyong {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url("/static/images/resource_yinyong_default.png") no-repeat;
    }

    .yinyong:hover {
      background: url("/static/images/resource_yinyong_hover.png") no-repeat;
    }

    .colSpan {
      h3 {
        word-break: break-all;
        font-size: 16px;
        font-weight: bold;
        color: #34343a;
        margin-bottom: 16px;
      }

      h3:hover {
        color: $btnc;
        cursor: pointer;
      }

      .acv {
        color: $btnc;
      }

      display: flex;
      justify-content: space-between;
    }

    p {
      color: #989ea2;
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 16px;

      span {
        margin-right: 12px;
        font-size: 12px;
      }
    }

    .text {
      font-size: 14px;
      color: #66686e;
    }
  }

  .limit-open-vip {
   /deep/ .el-dialog__title{
     font-weight: bold;
   }
 }

  .open-vip-box{
    display:flex;
    flex-direction: column;
    align-items:center;
    justify-content:space-between;

    .open-vip-box-message{
      margin-bottom: 20px;
    }

    .check-glod-btn {
      width: 134px;
      height: 36px;
      background: #c79758;
      opacity: 1;
      border-radius: 18px;
      border: none;
    }
    .check-btn-text {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 12px;
      color: #ffffff;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/writing/database.vue